import React from 'react';
import { Sidebar } from './Sidebar';
import { BillingBanner } from './BillingBanner';

export const Layout = ({ children }) => {
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-y-auto sf-main-bg">
        <BillingBanner />
        {children}
      </main>
    </div>
  );
};
